<template>
  <button
    class="l-button"
    :class="{ 'l-button--success': type === 'success', 'l-button--warning': type === 'warning', 'l-button--danger': type === 'danger' }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "LButton",
  props: {
    type: { type: String, default: "default" },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style lang="postcss">
.l-button---disabled {
  @apply bg-gray-400 border-gray-400;
  cursor: no-drop;
}
.l-button {
  @apply relative leading-none whitespace-no-wrap cursor-pointer bg-gray-400;
  @apply border border-gray-500 rounded text-center outline-none m-0 pl-5 pr-5 h-8;
  @apply text-sm font-bold text-pastel-black;

  box-sizing: border-box;
  transition: 0.1s;
  transition: all 0.3s;
  -webkit-appearance: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.l-button[disabled] {
  @apply l-button---disabled;
}

.l-button--success {
  @apply bg-pastel-green-500 border-pastel-green-500;
}
.l-button--success:hover {
  @apply bg-pastel-green-600 border-pastel-green-600;
}
.l-button--success[disabled] {
  @apply l-button---disabled;
}

.l-button--warning {
  @apply bg-orange-500 border-orange-500;
}
.l-button--warning:hover {
  @apply bg-orange-600 border-orange-600;
}
.l-button--warning[disabled] {
  @apply l-button---disabled;
}

.l-button--danger {
  @apply bg-red-500 border-red-500;
}
.l-button--danger:hover {
  @apply bg-red-600 border-red-600;
}
.l-button--danger[disabled] {
  @apply l-button---disabled;
}
</style>
